import Spacing from "@irati/ui/src/Spacing"
import React, {useMemo} from "react"
import {MobileSearchBar} from "./MobileSearchBar"
import styled, {css} from "styled-components"
import {PillsBar} from "../../components/PillsBar"
import {FilterDropDown} from "./FilterDropDown"
import {StoreGrid} from "./StoreGrid"
import {useStoreContext} from "../../context/StoreContext"
import {useStoreProductsQuery} from "@irati/payrollpay/hooks"
import {ProductCard} from "../../components/ProductCard"
import Loading from "@irati/ui/src/Loading"

export const StoreListing = () => {
  const {schemeType} = useStoreContext()
  const params = new URLSearchParams(window.location.search)

  const departments = params.get("departments")
  const categories = params.get("categories")
  const subcategories = params.get("subcategories")
  const bg = params.get("bg")
  const page = params.get("page")
  const resultsPerPage = params.get("results_per_page")
  const sortBy = params.get("sort_by")

  const filters = useMemo(() => {
    return {
      brands: [],
      promo: [],
      departments: departments ? [departments] : [],
      categories: categories ? [categories] : [],
      subcategories: subcategories ? [subcategories] : [],
      minPrice: null,
      maxPrice: null,
      search: null,
      bg: Number(bg) || null
    }
  }, [departments, categories, subcategories, bg])

  const {data, load} = useStoreProductsQuery(
    {
      schemeType,
      filters,
      page: Number(page) || null,
      productsPerPage: parseInt(resultsPerPage || "40"),
      orderBy: sortBy || null
    },
    {
      fetchPolicy: "cache-and-network"
    }
  )

  const brochureGroupsData = data?.employeeOrganisation?.scheme?.brochureGroups ?? []
  const departmentsData = data?.employeeOrganisation?.scheme?.store?.departments ?? []
  const products = data?.employeeOrganisation?.scheme?.store?.products ?? []
  const totalEntries = data?.employeeOrganisation?.scheme?.store?.totalEntries ?? 0

  return (
    <>
      <Spacing hideOnDesktop>
        <MobileSearchBar />
      </Spacing>
      <GreySection>
        <div className="container">
          <PillsBar departments={departmentsData} />
          <Loading load={load}>
            <FilterDropDown brochureGroups={brochureGroupsData} />
            {/* TODO: desktop sidebar filters */}
            <StoreGrid totalEntries={totalEntries}>
              {products &&
                products.map(({name, image, price, productId, url}) => (
                  <ProductCard key={productId} name={name} image={image || ""} price={price} url={url || ""} />
                ))}
            </StoreGrid>
          </Loading>
        </div>
      </GreySection>
    </>
  )
}

const GreySection = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.greys.grey03};
    width: 100%;
  `}
`
